import ErrorOutline from '@material-ui/icons/ErrorOutline';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from 'fuse-ui/components/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ( {
    icon: {
        color: theme.palette.text.hint
    },
    wrapper: {
        marginTop: theme.spacing.unit * 2,
        textAlign: 'center'
    }
} );

const ErrorMessage = ( { classes, icon, iconColor, message } ) => {
    const iconStyle = iconColor ? { color: iconColor } : classes.icon;

    return (
        <div className={classes.wrapper}>
            { icon && <span className={iconStyle}>{icon}</span> }
            <Typography align="center" variant="subtitle1" color="textSecondary" gutterBottom>
                {message}
            </Typography>
        </div>
    );
};

ErrorMessage.defaultProps = {
    icon: <ErrorOutline />,
    message: 'There is no data for this view.'
};

ErrorMessage.propTypes = {
    classes: PropTypes.object.isRequired,
    icon: PropTypes.object,
    iconColor: PropTypes.string,
    message: PropTypes.string
};

export default withStyles( styles )( ErrorMessage );
